'use client';

import Link from 'next/link';
import { useScrollIntoView } from '@/hooks/useScrollIntoView';
import { useState } from 'react';

const Navbar = () => {
  const scrollIntoView = useScrollIntoView();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="bg-white shadow-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex">
            <Link href="/" className="flex items-center">
              <img
                className="h-8 w-8 transition-transform duration-300 hover:scale-110"
                src="https://firebasestorage.googleapis.com/v0/b/auditleats.firebasestorage.app/o/compressed_1751228970524.webp?alt=media&token=fd943734-469f-4a1a-b64b-01ca45fb64f9"
                alt="AuditLeads Logo"
              />
              <span className="ml-2 font-bold text-xl transition-colors duration-300">
                Audit<span className="text-primary">Leads</span>
              </span>
            </Link>
          </div>
          {/* Desktop menu */}
          <div className="hidden sm:flex items-center space-x-8">
            <button
              onClick={() => scrollIntoView('analyzer')}
              className="px-4 py-2 rounded-lg hover:bg-gray-200 hover:text-white transition-all duration-200"
            >
              <span className="font-medium text-gray-600">
                Audit Your Website
              </span>
            </button>
            <button
              onClick={() => scrollIntoView('services')}
              className="px-4 py-2 rounded-lg hover:bg-gray-200 hover:text-white transition-all duration-200"
            >
              <span className="font-medium text-gray-600">
                Analytics
              </span>
            </button>
            <button
              onClick={() => scrollIntoView('how-it-works')}
              className="px-4 py-2 rounded-lg hover:bg-gray-200 hover:text-white transition-all duration-200"
            >
              <span className="font-medium text-gray-600">
                Optimization
              </span>
            </button>
            <button
              onClick={() => scrollIntoView('contact')}
              className="px-4 py-2 rounded-lg hover:bg-gray-200 hover:text-white transition-all duration-200"
            >
              <span className="font-medium text-gray-600">
                Consultation
              </span>
            </button>
          </div>
          {/* Mobile menu button */}
          <div className="sm:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary"
            >
              <span className="sr-only">Open main menu</span>
              <svg
                className={`${isOpen ? 'hidden' : 'block'} h-6 w-6`}
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
              <svg
                className={`${isOpen ? 'block' : 'hidden'} h-6 w-6`}
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>
      </div>
      {/* Mobile menu */}
      <div className={`${isOpen ? 'block' : 'hidden'} sm:hidden`}>
        <div className="px-2 pt-2 pb-3 space-y-1">
          <button
            onClick={() => {
              scrollIntoView('hero');
              setIsOpen(false);
            }}
            className="block px-6 py-3 rounded-lg hover:bg-gray-200 hover:text-white transition-all duration-200"
          >
            <span className="font-medium text-gray-600">
              Audit Your Website
            </span>
          </button>
          <button
            onClick={() => {
              scrollIntoView('services');
              setIsOpen(false);
            }}
            className="block px-6 py-3 rounded-lg hover:bg-gray-200 hover:text-white transition-all duration-200"
          >
            <span className="font-medium text-gray-600">
              Analytics
            </span>
          </button>
          <button
            onClick={() => {
              scrollIntoView('how-it-works');
              setIsOpen(false);
            }}
            className="block px-6 py-3 rounded-lg hover:bg-gray-200 hover:text-white transition-all duration-200"
          >
            <span className="font-medium text-gray-600">
              Optimization
            </span>
          </button>
          <button
            onClick={() => {
              scrollIntoView('contact');
              setIsOpen(false);
            }}
            className="block px-6 py-3 rounded-lg hover:bg-gray-200 hover:text-white transition-all duration-200"
          >
            <span className="font-medium text-gray-600">
              Consultation
            </span>
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
